<div class="container">
  <div class="d-flex flex-column">
    <h1 class="text-secondary text-center">Veuillez patienter, vous allez être redirigé vers la page d'accueil.</h1>
  </div>
</div>
